import { Float } from "../../models";
import { Box, Typography } from "@mui/material";
import React from "react";
import MainCard from "../shared/MainCard";
import { generateColorGradient } from "../../utils/generateColorGradient";
import { formatCurrency } from "../../utils/formatters";

type CurrentFloatViewProps = {
  float: Float;
};

export const CurrentFloatView = ({ float }: CurrentFloatViewProps) => {
  const colors = generateColorGradient(5);

  const displayInvoiceItem = (title: string, value: number, color: string) => {
    return (
      // @ts-ignore-next-line
      <MainCard
        content={false}
        sx={{
          width: "100%",
          backgroundColor: color,
          textAlign: "right",
          padding: 2
        }}
      >
        <Typography color="white">{title}</Typography>
        <Typography color="white" variant="h5" py={1}>
          {formatCurrency(value)}
        </Typography>
      </MainCard>
    );
  };

  return (
    <>
      <Typography variant="h6">
        Float Management
      </Typography>
      <Box display="flex" gap={2} pt={2}>
        {displayInvoiceItem("Total Contribution", float.totalContribution.amount, colors[0])}
        {displayInvoiceItem("Minimum Float Value", float.minimumAmount.amount, colors[1])}
        {displayInvoiceItem("Current Float Value", float.floatAmount.amount, colors[2])}
      </Box>
    </>
  );
};
